import { CatalogSectionProductColorPrice } from '../../catalogs/products/interfaces/catalogProductList.types';
import { ESProduct } from '../../products/product.types.v2';
import { OfflineDatabaseProductColorPriceInfoV2 } from '../database/offlineDatabase/types/offlineDatabaseProductColorPriceInfo.types';
import { offlineSizesRepository } from '../repositories/offlineSizes.repository';

export class OfflineProductColorPriceInfoTransformers {
  static async toCatalogSectionProductColorPrice(
    productColorPriceInfo: OfflineDatabaseProductColorPriceInfoV2,
  ): Promise<CatalogSectionProductColorPrice[]> {
    const sizeMap = await this.getSizeMap(productColorPriceInfo);

    const prices: CatalogSectionProductColorPrice[] = productColorPriceInfo.pricesToSizes.map(
      (price) => ({
        retailPrice: price.retailPrice,
        wholesalePrice: price.wholesalePrice,
        promotionalPrice: price.promotionalPrice,
        sizeName: sizeMap.get(price.sizeId)?.name as string,
        sizePosition: sizeMap.get(price.sizeId)?.position as number,
        priceCompositions: price.priceComposition?.map((pc) => ({ id: pc.id, price: pc.price })),
      }),
    );

    return prices;
  }

  static async toESProductPrice(
    productColorPriceInfo: OfflineDatabaseProductColorPriceInfoV2,
  ): Promise<ESProduct['prices']> {
    const sizeMap = await this.getSizeMap(productColorPriceInfo);

    return productColorPriceInfo.pricesToSizes.map((price) => ({
      retailPrice: price.retailPrice,
      wholesalePrice: price.wholesalePrice,
      promotionalPrice: price.promotionalPrice,
      sizeName: sizeMap.get(price.sizeId)?.name as string,
      sizePosition: sizeMap.get(price.sizeId)?.position as number,
    }));
  }

  private static async getSizeMap(productColorPriceInfo: OfflineDatabaseProductColorPriceInfoV2) {
    const sizeIds = productColorPriceInfo.pricesToSizes.map((price) => price.sizeId);
    const sizes = await offlineSizesRepository.findByIds(sizeIds);
    const sizeMap = new Map(sizes.map((size) => [size.id, size]));

    return sizeMap;
  }
}
